import { createStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  card: {
    boxShadow: theme.shadows[3],
    borderRadius: 10,
    height: '100%',
  },
  iconWrapper: {
    textAlign: 'center',
    margin: '15px 0 31px',
    width: '100%',
  },
  icon: {
    height: 250,
    fontSize: 114,
    backgroundSize: 'contain',
    color: '#3F51B5', // Blue color for thermostats
    display: 'block',
  },
  primaryText: {
    color: '#3F51B5', // Blue color for thermostats
    fontWeight: 'bold',
    fontSize: 22,
    lineHeight: '28px',
    '& .serialNumber': {
      fontWeight: 'bold',
      color: '#000',
    },
  },
  secondaryText: {
    fontSize: '16px',
    lineHeight: '20px',
    color: '#979797',
  },
  link: {
    color: '#3F51B5', // Use a hardcoded color instead of theme.appPalette
  },
});

export default styles;
